/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useSelectedUser } from '../../staff/SelectedUserProvider';
import { Select, notification } from 'antd';
import { useGetCompleteMenu, useGetHospitals } from '../../service/onboarding.service';
import { useBranchesByHospital, useGetAssignedBranches } from '../../service/branch.service';
import _groupBy from 'lodash/groupBy';
const _ = { groupBy: _groupBy };
import { getDashboardPathByRole } from '../../../utils/dashboardRoute';

const LockScreen = () => {

    const {
        hospital,
        setHospital,
        setMenuList,
        loginRole,
        loginUser,
        handleLogoutUser,
        assignedBranches,
        setLoginBranch
    } = useSelectedUser();
    const dashboardPath = getDashboardPathByRole(loginRole);

    const [curBranch, setCurBranch] = useState(0);
    const [hospitalId, setHospitalId] = useState(null);
    const [branches, setBranches] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    const { data: hospitals, isError, error, isLoading } = useGetHospitals();
    const { data: branchData, isFetched } = useBranchesByHospital(hospitalId);
    const { data: menus, isFetched: menuFetched } = useGetCompleteMenu(hospitalId);
    // Fetch the FULL list of branches assigned to this user (the login response
    // may only contain a subset), so multi-branch users are correctly shown the picker.
    const { data: assignedData, isFetched: assignedFetched } = useGetAssignedBranches(loginUser?.username);

    const assignedBranchesList = Array.isArray(assignedData?.data) && assignedData.data.length > 0
        ? assignedData.data
        : (Array.isArray(assignedBranches) ? assignedBranches : []);

    useEffect(() => {

        if (isFetched && loginRole?.roleType === 'SUPER_ADMIN') {
            setBranches(branchData?.data || []);
        }


        if (menuFetched && loginRole?.roleType === 'SUPER_ADMIN') {
          
            sessionStorage.setItem('hmsv2-mainMenu', JSON.stringify(_.groupBy(menus.data?.mainMenu, 'orderId')));
            sessionStorage.setItem('hmsv2-menu', JSON.stringify(menus.data?.menus));
            sessionStorage.setItem('hmsv2-submenu', JSON.stringify(menus.data?.submenus));

            setMenuList({
                'mainMenus': _.groupBy(menus.data?.mainMenu, 'orderId'),
                'menus': menus.data?.menus,
                'submenus': menus.data?.submenus
            });
        }

    }, [isFetched, menuFetched]);

    // Auto-select branch ONLY if the user has exactly 1 assigned branch (non-SUPER_ADMIN).
    // Uses the FULL fetched branch list, so a user with 2+ branches is never auto-logged in.
    useEffect(() => {
        if (loginRole?.roleType === 'SUPER_ADMIN' || !assignedFetched) {
            return;
        }

        console.log('[LockScreen] fetched assigned branches:', assignedBranchesList, 'role:', loginRole?.roleType);

        if (!Array.isArray(assignedBranchesList) || assignedBranchesList.length !== 1) {
            return;
        }

        const singleBranch = assignedBranchesList[0];
        setCurBranch(singleBranch.branchId);
        setSubmitting(true);
        sessionStorage.setItem('hmsv2-branch', JSON.stringify(singleBranch));
        setLoginBranch(singleBranch);
        window.location.replace(dashboardPath);
    }, [loginRole, assignedFetched, assignedBranchesList]);

    const submitBranch = (e) => {
        e?.preventDefault?.();

        if (submitting) {
            return;
        }

        if (!curBranch) {
            notification.warning({ message: 'Please select a branch' });
            return;
        }

        let acurbranch = (loginRole?.roleType === 'SUPER_ADMIN')
            ? branches.filter(branch => branch.branchId === curBranch)
            : assignedBranchesList.filter(branch => branch.branchId === curBranch);

        if (loginRole?.roleType === 'SUPER_ADMIN') {
            if (!hospitalId) {
                notification.warning({ message: 'Please select a hospital' });
                return;
            }
            const acurhospital = (hospitals?.data || []).filter(h => h.hospitalId === hospitalId);
            if (!acurhospital.length) {
                notification.error({ message: 'Selected hospital was not found' });
                return;
            }

            sessionStorage.setItem('hmsv2-hospital', JSON.stringify(acurhospital[0]));
            setHospital(acurhospital[0]);
        }

        if (acurbranch.length > 0) {
            setSubmitting(true);
            sessionStorage.setItem('hmsv2-branch', JSON.stringify(acurbranch[0]));
            sessionStorage.setItem('hmsv2-branch-manual', '1');
            setLoginBranch(acurbranch[0]);
            window.location.replace(dashboardPath);
            return;
        }

        notification.warning({ message: 'Please select a valid branch' });
    };

    useEffect(() => {
        if (isError) {
            notification.warning({
                message: 'You cannot login to the system at this time, please consult your Admin...',
                description: error?.response?.data?.message || error?.message,
            });
        }
    }, [isError, error]);


    return (
        <div className="main-wrapper login-body">
            <div className="container-fluid px-0">
                <div className="row g-0">
                    <div className="col-lg-6 d-none d-lg-flex bela-login-panel">
                        <div className="bela-brand-block">
                            <div className="bela-brand-logo">HMS</div>
                            <p className="bela-brand-tagline">
                                Select your workspace to continue with HMS.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 bela-login-form-wrap">
                        <div className="bela-login-card">
                            <div className="d-lg-none text-center mb-4">
                                <div className="bela-brand-logo" style={{ color: 'var(--bela-primary)', fontSize: '2rem' }}>
                                    HMS
                                </div>
                            </div>
                            <div className="user-lock-screen">
                                <h2>Hi, {loginUser.firstName}</h2>
                                {assignedBranchesList.length === 1 && loginRole?.roleType !== 'SUPER_ADMIN' ? (
                                    <p style={{ color: 'var(--bela-accent)' }}>
                                        Logging you in to {assignedBranchesList[0].name}...
                                    </p>
                                ) : (
                                    <p style={{ color: 'var(--bela-accent)' }}>
                                        Select {loginRole?.roleType === 'SUPER_ADMIN' && `a hospital and`} a branch to start working!
                                    </p>
                                )}
                            </div>
                            <form onSubmit={submitBranch}>
                                {loginRole?.roleType !== 'SUPER_ADMIN' &&
                                    <p className='mb-4 text-center fw-bold fs-4' style={{ color: 'var(--bela-primary)' }}>
                                        {hospital?.name}
                                    </p>}
                                {loginRole?.roleType !== 'SUPER_ADMIN' && assignedBranchesList.length > 1 && <div className="form-group mb-3">
                                    <label className="bela-form-label" style={{ zIndex: 2000 }}>Assigned Branch(es)</label>
                                    <Select className="form-control" placeholder="Select Branch"
                                        variant="borderless" onChange={(value) => setCurBranch(value)}>
                                        {assignedBranchesList.map((branch, idx) => (
                                            <Select.Option key={idx} value={branch.branchId}>{branch.name}</Select.Option>))}
                                    </Select>
                                </div>}

                                {loginRole?.roleType === 'SUPER_ADMIN' && <div className="form-group mb-3">
                                    <label className="bela-form-label" style={{ zIndex: 2000 }}>Hospital</label>
                                    <Select className="form-control" placeholder="Select Hospital" value={hospitalId}
                                        variant="borderless" onChange={(value) => setHospitalId(value)}>
                                        {(hospitals?.data || []).map((hospital, idx) => (
                                            <Select.Option key={idx} value={hospital.hospitalId}>{hospital.name}</Select.Option>))}
                                    </Select>
                                </div>}
                                {loginRole?.roleType === 'SUPER_ADMIN' && <div className="form-group mb-3">
                                    <label className="bela-form-label" style={{ zIndex: 2000 }}>Branches</label>
                                    <Select className="form-control" placeholder="Select Branch"
                                        variant="borderless" onChange={(value) => setCurBranch(value)}
                                        disabled={!hospitalId || isLoading}>
                                        {branches.map((branch, idx) => (
                                            <Select.Option key={idx} value={branch.branchId}>{branch.name}</Select.Option>))}
                                    </Select>
                                </div>}

                                <div className="form-group login-btn mb-3">
                                    <button
                                        className="btn btn-primary btn-block w-100"
                                        type="submit"
                                        disabled={submitting}
                                    >
                                        {submitting
                                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Loading...</>
                                            : 'Continue to branch'}
                                    </button>
                                </div>
                            </form>
                            <div className="next-sign">
                                <p className="account-subtitle mb-0">
                                    Sign in as a different user?{" "}
                                    <Link to="/#" onClick={handleLogoutUser}>Login</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LockScreen;
